import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

function SideNav() {
  return (
    <>
      <aside className="left-sidebar">
        {/* Sidebar scroll*/}
        <div className="scroll-sidebar">
          {/* Sidebar navigation*/}
          <nav className="sidebar-nav">
            <ul id="sidebarnav">
              <li className="user-pro">
                <a className="waves-effect waves-dark" onClick={(e) => e.preventDefault()} aria-expanded="false">
                  <img src="/materialdashboard/images/users/1.jpg" alt="user-img" className="img-circle" />
                  <span className="hide-menu">Prashant Silpakar</span>
                </a>
              </li>
              <li>
                <Link to="/" className="waves-effect waves-dark" aria-expanded="false">
                  <i className="icon-speedometer" />
                  <span className="hide-menu">Dashboard</span>
                </Link>
              </li>
              <li>
                <a className="has-arrow waves-effect waves-dark" onClick={(e) => e.preventDefault()} aria-expanded="false">
                  <i className="ti-layout-grid2" />
                  <span className="hide-menu">Content</span>
                </a>
                <ul aria-expanded="false" className="collapse">
                  <li><Link to="/admin/content/create">Add Content</Link></li>
                  <li><Link to="/admin/contents">List app</Link></li>
                </ul>
              </li>

              <li>
                <a className="has-arrow waves-effect waves-dark" onClick={(e) => e.preventDefault()} aria-expanded="false">
                  <i className="ti-layout-grid2" />
                  <span className="hide-menu">Package Category</span>
                </a>
                <ul aria-expanded="false" className="collapse">
                  <li><Link to="/admin/category/create">Add Category</Link></li>
                  <li><Link to="/admin/categories">List app</Link></li>
                </ul>
              </li>
              <li>
                <a className="has-arrow waves-effect waves-dark" onClick={(e) => e.preventDefault()} aria-expanded="false">
                  <i className="ti-layout-grid2" />
                  <span className="hide-menu">Packages</span>
                </a>
                <ul aria-expanded="false" className="collapse">
                  <li><a href="app-calendar.html">Add Package</a></li>
                  <li><a href="app-chat.html">List Packages</a></li>
                </ul>
              </li>
            </ul>
          </nav>
          {/* End Sidebar navigation */}
        </div>
        {/* End Sidebar scroll*/}
      </aside>

    </>

  );
}

export default SideNav;
